import { MetricDetails } from '../../../../../../api/metrics/types';
import { DomainPreferences } from '../../../../../../api/types';
import { MetricId } from '../../../../../../api/types-graphql';
import { DataFieldValueFormatter } from '../../../../../hooks';
import {
  BarChartLayouts,
  ChartData,
} from '../../../../ui-components/data-viz-ui/charts/common/common-chart-types';
import {
  ComponentStateManager,
  DataVizContainerCommonUtils,
} from '../../../common/types';
import {
  getBarChartTableDataFromChartData,
  getChartDataFromSegmentedResponse,
} from '../../../common/utils';
import {
  TimePeriodSegmentedVizData,
  TimePeriodSegmentedVizDataResponse,
  TimePeriodSegmentedVizExternalProps,
} from '../../types';
import {
  TimePeriodSegmentedTableViewActions,
  TimePeriodSegmentedTableViewState,
  TimePeriodSegmentedTableViewUiComponentProps,
} from './types';

const getChartDataFromTimePeriodSingleQueryResponse = (
  response: TimePeriodSegmentedVizDataResponse,
  preferences: DomainPreferences,
  metricDetailsMap: Partial<Record<MetricId, MetricDetails>>,
  metricDisplayValues: Partial<Record<MetricId, string>>,
  dataFieldValueFormatter: DataFieldValueFormatter
): ChartData => {
  return getChartDataFromSegmentedResponse(
    {
      ...response,
      isSegmented: true,
    },
    preferences,
    metricDetailsMap,
    metricDisplayValues,
    dataFieldValueFormatter
  );
};

export const timePeriodSegmentedTableViewDataToUiComponentProps = (
  data: TimePeriodSegmentedVizData,
  externalProps: TimePeriodSegmentedVizExternalProps,
  componentStateManager: ComponentStateManager<
    TimePeriodSegmentedTableViewState,
    TimePeriodSegmentedTableViewActions
  >,
  { dataFieldValueFormatter }: DataVizContainerCommonUtils
): TimePeriodSegmentedTableViewUiComponentProps => {
  const { fullScreenHandle, preferences } = externalProps;
  const { dataResponse, titleConfig, metricDetails, metricDisplayValues } =
    data;
  const chartData = getChartDataFromTimePeriodSingleQueryResponse(
    dataResponse,
    preferences,
    metricDetails,
    metricDisplayValues,
    dataFieldValueFormatter
  );
  const { layout = BarChartLayouts.GROUPED, selectedSortOrder } =
    componentStateManager.state.displayState;
  const tableData = getBarChartTableDataFromChartData(chartData, {
    layout,
    selectedSortOrder,
  });
  const displayConfig = {
    ...componentStateManager.state.displayState,
    ...componentStateManager.actions.displayActions,
  };
  return {
    fullScreenHandle,
    displayConfig,
    titleConfig,
    tableData,
  };
};
